import { gql, useMutation } from '@apollo/client';
import { FILE_FIELDS } from '@dieterApi/topic/useTopicsQuery';
import { UserFile } from '@dieterApi/user/useUserQuery';

const DELETE_FILE = gql`
  ${FILE_FIELDS}
  mutation DeleteFile($id: String!) {
    deleteFile(id: $id) {
      ...UserFileFields
    }
  }
`;

export interface FileDeleteInput {
  id: string;
}

export interface FileDeleteResult {
  deleteFile: UserFile;
}

export interface FileDeleteContext {
  topicId: string;
}

export function useFileDeleteMutation() {
  return useMutation<FileDeleteResult, FileDeleteInput, FileDeleteContext>(DELETE_FILE, {
    update: (cache, { data }) => {
      cache.evict({ id: `File:${data?.deleteFile.id}` });
    },
  });
}
